import LoadMoreButton from '@atoms/LoadMoreButton/LoadMoreButton';
import LoadingSpinner from '@atoms/LoadingSpinner/LoadingSpinner';
import { IListingResult } from '@models/IListingResult';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

interface Props {
  readonly alignLeft?: boolean;
  readonly error: boolean;
  readonly loading: boolean;
  readonly loadMoreLabel: string;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly results: IListingResult[];
  readonly paginationHandler: (params: number) => void;
  readonly total: number;
  readonly hasNextPage: boolean;
  readonly viewedLabel?: string;
}

const LoadMoreListing = ({
  alignLeft = false,
  error,
  loading,
  loadMoreLabel,
  pageNumber,
  pageSize = 0,
  results,
  paginationHandler,
  total,
  hasNextPage,
  viewedLabel,
}: Props) => {
  const [viewLabel, setViewLabel] = useState('');

  useEffect(() => {
    if (viewedLabel) {
      const resultCount =
        results?.length < (pageNumber + 1) * pageSize
          ? results.length
          : (pageNumber + 1) * pageSize;

      const newLabel = viewedLabel
        ?.replace('{0}', `${resultCount}`)
        .replace('{1}', `${total}`);

      setViewLabel(newLabel);
    }
  }, [results, pageNumber, pageSize, total, viewedLabel]);

  if (error || !results?.length) {
    return null;
  }

  return (
    <div
      className={classNames(
        'space-y-5 bg-white text-black-100 dark:bg-black-100 dark:text-white',
        {
          'flex w-full flex-col items-center justify-center': !alignLeft,
        }
      )}
    >
      {!loading ? (
        <>
          {viewLabel && <div>{viewLabel}</div>}
          {hasNextPage && (
            <LoadMoreButton
              loadMoreLabel={loadMoreLabel}
              onClick={() => paginationHandler(pageNumber + 1)}
            />
          )}
        </>
      ) : (
        <LoadingSpinner extraClasses="pt-13" />
      )}
    </div>
  );
};

export default LoadMoreListing;
